export default {
  title: 'Connecting students and tutors across 5 nations worldwide',
  subtitle: '',
  img: '/front-img/public/world.png',
  findTutorTitle: 'Explore Ostado for endless learning possibilities. Find your perfect tutor effortlessly.',
  countries: {
    title: 'Active in 5 Countries Worldwide',
    description: 'Our platform bridges diverse cultural backgrounds, fostering a global community of learning. We believe in a world where knowledge knows no boundaries.'
  }
}
